<template>
  <div>
    <div
      v-if="video.is_favorite"
      key="like"
      class="favorite"
      @click="sendFavorite(false)"
    >
      <BaseIcon
        class="text-red-500 transition-all duration-500 hover:text-red-300"
        name="heart"
      />
    </div>
    <div v-else key="dislike" class="favorite" @click="sendFavorite(true)">
      <BaseIcon
        class="text-red-300 transition-all duration-500 hover:text-red-500"
        :name="['far', 'heart']"
      />
    </div>
  </div>
</template>

<script>
import videoListItemContentMixin from '@/mixins/videoListItemContentMixin'

export default {
  mixins: [videoListItemContentMixin],

  methods: {
    sendFavorite(status) {
      const payload = { video: this.video.pk, is_favorite: status }
      this.$store.dispatch('favorites/setFavorite', payload)
    },
  },
}
</script>

<style scoped>
.favorite {
  @apply text-xl leading-4 cursor-pointer flex absolute z-10 top-0 right-0 mt-2 mr-2 bg-white w-10 h-10 flex items-center justify-center rounded-full border;
}
</style>
